import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';
import Link from '@common/Link';
import Heading from '@common/Heading';

const Card = ({ data }) => {
  const {
    link,
    linkCopy,
    title,
    subtitle,
    image
  } = data;
  return (
    <div>
      <Link to={link} className='no-hover h-100'>
        <div className={clsx('d-flex flex-column card  scale-05 text-black h-100 border border-2 border-dark-grey-4 rounded')}>
          {image && <Img image={image.gatsbyImageData} file={image.file}/>}
          <div className='d-flex flex-column justify-content-between p-2'>
            {title && <Heading type='h3' className='h4'>{title}</Heading>}
            {subtitle && <p className='fw-normal'>{subtitle}</p>}
          </div>
          {linkCopy && <p className='px-2 mt-auto fs-16 text-blue show-hover'>{linkCopy}</p>}
        </div>
      </Link>
    </div>
  )
}

export default Card
